import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { Card } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

interface User {
  id: string
  email: string
  phone: string
  role: 'PASSENGER' | 'DRIVER' | 'ADMIN'
  createdAt: string
}

interface UsersResponse {
  data: User[]
  total: number
  skip: number
  take: number
}

function useUsers() {
  return useQuery<UsersResponse>({
    queryKey: ['users'],
    queryFn: async () => {
      const { data } = await api.get('/users')
      return data
    },
    staleTime: 30_000,
    gcTime: 5 * 60 * 1000,
    retry: 2,
  })
}

export default function UsersPage() {
  const { data, isLoading, isError } = useUsers()
  const users = data?.data ?? []

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Utilisateurs</h1>
      <Card>
        {isLoading && <p className="p-6 text-gray-500">Chargement…</p>}
        {isError && <p className="p-6 text-danger">Erreur lors du chargement des utilisateurs.</p>}
        {!isLoading && !isError && (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Email</TableHead>
                <TableHead>Téléphone</TableHead>
                <TableHead>Rôle</TableHead>
                <TableHead>Inscrit le</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {users.map((u) => (
                <TableRow key={u.id}>
                  <TableCell>{u.email}</TableCell>
                  <TableCell>{u.phone ?? '—'}</TableCell>
                  <TableCell>{u.role}</TableCell>
                  <TableCell>{new Date(u.createdAt).toLocaleDateString('fr-TN')}</TableCell>
                </TableRow>
              ))}
              {users.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} className="text-center text-gray-400">
                    Aucun utilisateur.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </Card>
    </div>
  )
}
